import Tokenizer from "shift-parser/dist/tokenizer";
import {TokenClass, TokenType} from "shift-parser/dist/tokenizer";
import {List} from "immutable";
import Syntax from "./syntax";
import  * as R from "ramda";
import {Maybe} from "ramda-fantasy";
import {assert} from "./errors";
const Just_489 = Maybe.Just;
const Nothing_490 = Maybe.Nothing;
import Term from "./terms";
const LSYNTAX_491 = {name: "left-syntax"};
const RSYNTAX_492 = {name: "right-syntax"};
const AT_493 = {klass: TokenClass.Punctuator, name: "@"};
const literalKeywords_494 = ["this", "null", "true", "false"];
const isLeftBracket_495 = R.whereEq({type: TokenType.LBRACK});
const isLeftBrace_496 = R.whereEq({type: TokenType.LBRACE});
const isLeftParen_497 = R.whereEq({type: TokenType.LPAREN});
const isRightBracket_498 = R.whereEq({type: TokenType.RBRACK});
const isRightBrace_499 = R.whereEq({type: TokenType.RBRACE});
const isRightParen_500 = R.whereEq({type: TokenType.RPAREN});
const isEOS_501 = R.whereEq({type: TokenType.EOS});
const isHash_502 = R.whereEq({type: TokenType.IDENTIFIER, value: "#"});
const isLeftSyntax_503 = R.whereEq({type: LSYNTAX_491});
const isRightSyntax_504 = R.whereEq({type: RSYNTAX_492});
const isLeftDelimiter_505 = R.anyPass([isLeftBracket_495, isLeftBrace_496, isLeftParen_497, isLeftSyntax_503]);
const isRightDelimiter_506 = R.anyPass([isRightBracket_498, isRightBrace_499, isRightParen_500, isRightSyntax_504]);
const isMatchingDelimiters_507 = R.cond([[isLeftBracket_495, (__548, b_549) => isRightBracket_498(b_549)], [isLeftBrace_496, (__550, b_551) => isRightBrace_499(b_551)], [isLeftParen_497, (__552, b_553) => isRightParen_500(b_553)], [isLeftSyntax_503, (__554, b_555) => isRightSyntax_504(b_555)], [R.T, R.F]]);
const assignOps_508 = ["=", "+=", "-=", "*=", "/=", "%=", "<<=", ">>=", ">>>=", "&=", "|=", "^=", ","];
const binaryOps_509 = ["+", "-", "*", "/", "%", "<<", ">>", ">>>", "&", "|", "^", "&&", "||", "?", ":", "===", "==", ">=", "<=", "<", ">", "!=", "!==", "instanceof"];
const unaryOps_510 = ["++", "--", "~", "!", "delete", "void", "typeof", "yield", "throw", "new"];
const isEmpty_511 = R.whereEq({size: 0});
const isPunctuator_512 = s_556 => s_556.isPunctuator();
const isKeyword_513 = s_557 => s_557.isKeyword();
const isDelimiter_514 = s_558 => s_558.isDelimiter();
const isParens_515 = s_559 => s_559.isParens();
const isBraces_516 = s_560 => s_560.isBraces();
const isBrackets_517 = s_561 => s_561.isBrackets();
const isIdentifier_518 = s_562 => s_562.isIdentifier();
const val_519 = s_563 => s_563.val();
const isVal_520 = R.curry((v_564, s_565) => s_565.val() === v_564);
const isDot_521 = R.allPass([isPunctuator_512, isVal_520(".")]);
const isColon_522 = R.allPass([isPunctuator_512, isVal_520(":")]);
const isFunctionKeyword_523 = R.allPass([isKeyword_513, isVal_520("function")]);
const isOperator_524 = s_566 => (s_566.isPunctuator() || s_566.isKeyword()) && R.any(R.equals(s_566.val()), assignOps_508.concat(binaryOps_509).concat(unaryOps_510));
const isNonLiteralKeyword_525 = R.allPass([isKeyword_513, s_567 => R.none(R.equals(s_567.val()), literalKeywords_494)]);
const isKeywordExprPrefix_526 = R.allPass([isKeyword_513, s_568 => R.any(R.equals(s_568.val()), ["instanceof", "typeof", "delete", "void", "yield", "throw", "new", "case"])]);
let last_527 = p_569 => p_569.last();
let safeLast_528 = R.pipe(R.cond([[isEmpty_511, R.always(Nothing_490())], [R.T, R.compose(Maybe.of, last_527)]]));
let stuffTrue_529 = R.curry((p_570, b_571) => b_571 ? Just_489(p_570) : Nothing_490());
let stuffFalse_530 = R.curry((p_572, b_573) => !b_573 ? Just_489(p_572) : Nothing_490());
let isTopColon_531 = R.pipe(safeLast_528, R.map(isColon_522), Maybe.maybe(false, R.identity));
let isTopPunctuator_532 = R.pipe(safeLast_528, R.map(isPunctuator_512), Maybe.maybe(false, R.identity));
let isExprReturn_533 = R.curry((l_574, p_575) => {
  let retKwd_576 = safeLast_528(p_575);
  let maybeDot_577 = pop_544(p_575).chain(safeLast_528);
  if (maybeDot_577.map(isDot_521).getOrElse(false)) {
    return true;
  }
  return retKwd_576.map(s_578 => {
    return s_578.isKeyword() && s_578.val() === "return" && s_578.lineNumber() === l_574;
  }).getOrElse(false);
});
const isTopOperator_534 = R.pipe(safeLast_528, R.map(isOperator_524), Maybe.maybe(false, R.identity));
const isTopKeywordExprPrefix_535 = R.pipe(safeLast_528, R.map(isKeywordExprPrefix_526), Maybe.maybe(false, R.identity));
let isExprPrefix_536 = R.curry((l_579, b_580) => R.cond([[isEmpty_511, R.always(b_580)], [isTopColon_531, R.always(b_580)], [isTopKeywordExprPrefix_535, R.T], [isTopOperator_534, R.T], [isTopPunctuator_532, R.always(b_580)], [isExprReturn_533(l_579), R.T], [R.T, R.F]]));
let curly_537 = p_581 => safeLast_528(p_581).map(isBraces_516).chain(stuffTrue_529(p_581));
let paren_538 = p_582 => safeLast_528(p_582).map(isParens_515).chain(stuffTrue_529(p_582));
let func_539 = p_583 => safeLast_528(p_583).map(isFunctionKeyword_523).chain(stuffTrue_529(p_583));
let ident_540 = p_584 => safeLast_528(p_584).map(isIdentifier_518).chain(stuffTrue_529(p_584));
let nonLiteralKeyword_541 = p_585 => safeLast_528(p_585).map(isNonLiteralKeyword_525).chain(stuffTrue_529(p_585));
let opt_542 = R.curry((a_586, b_587, p_588) => {
  let result_589 = R.pipeK(a_586, b_587)(Maybe.of(p_588));
  return Maybe.isJust(result_589) ? result_589 : Maybe.of(p_588);
});
let notDot_543 = R.ifElse(R.whereEq({size: 0}), Just_489, p_590 => safeLast_528(p_590).map(s_591 => !(s_591.isPunctuator() && s_591.val() === ".")).chain(stuffTrue_529(p_590)));
let pop_544 = R.compose(Just_489, p_592 => p_592.pop());
const functionPrefix_545 = R.pipeK(curly_537, pop_544, paren_538, pop_544, opt_542(ident_540, pop_544), func_539);
const isRegexPrefix_546 = b_593 => R.anyPass([isEmpty_511, isTopPunctuator_532, R.pipe(Maybe.of, R.pipeK(nonLiteralKeyword_541, pop_544, notDot_543), Maybe.isJust), R.pipe(Maybe.of, R.pipeK(paren_538, pop_544, nonLiteralKeyword_541, pop_544, notDot_543), Maybe.isJust), R.pipe(Maybe.of, functionPrefix_545, R.chain(p_594 => {
  return safeLast_528(p_594).map(s_595 => s_595.lineNumber()).chain(fnLine_596 => {
    return pop_544(p_594).map(isExprPrefix_536(fnLine_596, b_593));
  }).chain(stuffFalse_530(p_594));
}), Maybe.isJust), p_597 => {
  let isCurly_598 = Maybe.isJust(safeLast_528(p_597).map(isBraces_516));
  let alreadyCheckedFunction_599 = R.pipe(Maybe.of, functionPrefix_545, Maybe.isJust)(p_597);
  if (alreadyCheckedFunction_599) {
    return false;
  }
  return R.pipe(Maybe.of, R.chain(curly_537), R.chain(p_600 => {
    return safeLast_528(p_600).map(s_601 => s_601.lineNumber()).chain(curlyLine_602 => {
      return pop_544(p_600).map(isExprPrefix_536(curlyLine_602, b_593));
    }).chain(stuffFalse_530(p_600));
  }), Maybe.isJust)(p_597);
}]);
function lastEl_547(l_603) {
  return l_603[l_603.length - 1];
}
export default class Reader extends Tokenizer {
  constructor(strings_604, context_605, replacements_606) {
    super(Array.isArray(strings_604) ? strings_604.join("") : strings_604);
    this.delimStack = new Map;
    this.insideSyntaxTemplate = [false];
    this.context = context_605;
    if (Array.isArray(strings_604)) {
      let totalIndex = 0;
      this.replacementIndex = R.reduce((acc_607, strRep_608) => {
        acc_607.push({index: totalIndex + strRep_608[0].length, replacement: strRep_608[1]});
        totalIndex += strRep_608[0].length;
        return acc_607;
      }, [], R.zip(strings_604, replacements_606));
    }
  }
  read(stack_609 = [], b_610 = false, singleDelimiter_611 = false) {
    let prefix_612 = List();
    while (true) {
      let tok = this.advance(prefix_612, b_610);
      if (tok instanceof Syntax || tok instanceof Term) {
        stack_609.push(tok);
        continue;
      }
      if (Array.isArray(tok)) {
        Array.prototype.push.apply(stack_609, tok);
        continue;
      }
      if (List.isList(tok)) {
        Array.prototype.push.apply(stack_609, tok.toArray());
        continue;
      }
      if (isEOS_501(tok)) {
        if (stack_609[0] && isLeftDelimiter_505(stack_609[0].token)) {
          throw this.createUnexpected(tok);
        }
        break;
      }
      if (isLeftDelimiter_505(tok)) {
        if (isLeftSyntax_503(tok)) {
          this.insideSyntaxTemplate.push(true);
        }
        let line = tok.slice.startLocation.line;
        let innerB = isLeftBrace_496(tok) ? isExprPrefix_536(line, b_610)(prefix_612) : true;
        let inner = this.read([new Syntax(tok)], innerB, false);
        let stx = new Syntax(inner, this.context);
        prefix_612 = prefix_612.concat(stx);
        stack_609.push(stx);
        if (singleDelimiter_611) {
          break;
        }
      } else if (isRightDelimiter_506(tok)) {
        if (stack_609[0] && !isMatchingDelimiters_507(stack_609[0].token, tok)) {
          throw this.createUnexpected(tok);
        }
        let stx = new Syntax(tok, this.context);
        stack_609.push(stx);
        if (lastEl_547(this.insideSyntaxTemplate) && isRightSyntax_504(tok)) {
          this.insideSyntaxTemplate.pop();
        }
        break;
      } else {
        let stx = new Syntax(tok, this.context);
        prefix_612 = prefix_612.concat(stx);
        stack_609.push(stx);
      }
    }
    return List(stack_609);
  }
  advance(prefix_613, b_614) {
    let startLocation_615 = this.getLocation();
    this.lastIndex = this.index;
    this.lastLine = this.line;
    this.lastLineStart = this.lineStart;
    this.skipComment();
    this.startIndex = this.index;
    this.startLine = this.line;
    this.startLineStart = this.lineStart;
    if (this.replacementIndex && this.replacementIndex[0] && this.index >= this.replacementIndex[0].index) {
      let rep = this.replacementIndex[0].replacement;
      this.replacementIndex.shift();
      return rep;
    }
    let charCode_616 = this.source.charCodeAt(this.index);
    if (charCode_616 === 96) {
      let element, items = [];
      let startLocation_615 = this.getLocation();
      let start = this.index;
      this.index++;
      if (lastEl_547(this.insideSyntaxTemplate)) {
        let slice = this.getSlice(start, startLocation_615);
        return {type: RSYNTAX_492, value: "`", slice: slice};
      }
      do {
        element = this.scanTemplateElement();
        items.push(element);
        if (element.interp) {
          element = this.read([], false, true);
          assert(element.size === 1, "should only have read a single delimiter inside a template");
          items.push(element.get(0));
        }
      } while (!element.tail);
      return {type: TokenType.TEMPLATE, items: List(items)};
    } else if (charCode_616 === 35) {
      let startLocation_615 = this.getLocation();
      let start = this.index;
      let slice = this.getSlice(start, startLocation_615);
      this.index++;
      if (this.source.charCodeAt(this.index) === 96) {
        this.index++;
        return {type: LSYNTAX_491, value: "#`", slice: slice};
      }
      return {type: TokenType.IDENTIFIER, value: "#", slice: slice};
    } else if (charCode_616 === 64) {
      let startLocation_615 = this.getLocation();
      let start = this.index;
      let slice = this.getSlice(start, startLocation_615);
      this.index++;
      return {type: AT_493, value: "@", slice: slice};
    }
    let lookahead_617 = super.advance();
    if (lookahead_617.type === TokenType.DIV && isRegexPrefix_546(b_614)(prefix_613)) {
      return super.scanRegExp("/");
    }
    return lookahead_617;
  }
  scanTemplateElement() {
    let startLocation_618 = this.getLocation();
    let start_619 = this.index;
    while (this.index < this.source.length) {
      let ch = this.source.charCodeAt(this.index);
      switch (ch) {
        case 96:
          let slice = this.getSlice(start_619, startLocation_618);
          this.index++;
          return {type: TokenType.TEMPLATE, tail: true, interp: false, slice: slice};
        case 36:
          if (this.source.charCodeAt(this.index + 1) === 123) {
            let slice = this.getSlice(start_619, startLocation_618);
            this.index += 1;
            return {type: TokenType.TEMPLATE, tail: false, interp: true, slice: slice};
          }
          this.index++;
          break;
        case 92:
          {
            let octal = this.scanStringEscape("", null)[1];
            if (octal != null) {
              throw this.createILLEGAL();
            }
            break;
          }
        default:
          this.index++;
      }
    }
    throw this.createILLEGAL();
  }
}
